import { IComponentOptions } from 'angular';
import { CreditGapsWizardGradPlanTableCtrl } from './credit-gaps-wizard-grad-plan-table.controller';

export const CreditGapsWizardGradPlanTableComponent: IComponentOptions = {
  bindings: {
    currentSchool: '<',
    currentFilter: '<',
  },
  controller: CreditGapsWizardGradPlanTableCtrl,
  template: require('./credit-gaps-wizard-grad-plan-table.html'),
};
